import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { ErrorMessage } from 'app/core/error-handler/constants';
import { Error } from 'app/core/error-handler/models';
import { createErrorRaised } from 'app/core/error-handler/state/actions';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { ErgoRoleInterface } from '../models/ergo-role.model';
import { RoleInterface } from '../models/role.model';
import { RoleRestConnectorService } from '../services/role-rest-connector.service';

import { RoleActionType } from './actions/role-actions.enum';
import { LoadErgoRolesComplete, LoadRolesComplete } from './actions/role-load.actions';

@Injectable()
export class RoleEffects {
  public source: string = 'RoleEffects';

  @Effect()
  public loadAllRoles$: Observable<Action> = this.action$
  .pipe(
    ofType(RoleActionType.LoadRoles),
    switchMap(() => this._roleConnector.loadAllRoles()
    .pipe(
      map((roles: RoleInterface[]) => new LoadRolesComplete(roles)),
      catchError((err: any) => of(createErrorRaised(new Error({
        message: ErrorMessage.unexpected,
        errorResponse: err,
        source: this.source,
      })))),
    )),
  );

  @Effect()
  public loadAllErgoRoles$: Observable<Action> = this.action$
  .pipe(
    ofType(RoleActionType.LoadErgoRoles),
    switchMap(() => this._roleConnector.loadAllErgoRoles()
    .pipe(
      map((roles: ErgoRoleInterface[]) => new LoadErgoRolesComplete(roles)),
      catchError((err: any) => of(createErrorRaised(new Error({
        message: ErrorMessage.unexpected,
        errorResponse: err,
        source: this.source,
      })))),
    )),
  );

  constructor(private readonly action$: Actions, private readonly _roleConnector: RoleRestConnectorService) {}
}
